module.exports = __webpack_public_path__ + "img/1529330254.ed0a97ef.jpg";